import styled from 'styled-components';

export const TrackingDetailsContainer = styled.div(({ theme }) => ({
  background: theme.colors.surface01,
  boxShadow: '0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16)',

  [`${theme.mediaBreakpointUp.lg}`]: {
    borderRadius: 4,
    borderTop: `4px solid ${theme.colors.darkOrange}`,
    background: theme.colors.highEmphasisWhite,
  },
}));

export const AffiliateSectionContainer = styled(TrackingDetailsContainer)`
  margin-top: 24px;

  > div {
    border: none;
  }
`;

export const TrackingDetailsInnerContainer = styled.div(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
  padding: theme.spacing[20],

  [`${theme.mediaBreakpointUp.lg}`]: {
    borderRadius: 4,
    gap: theme.spacing[24],
    background: theme.colors.highEmphasisWhite,
  },
}));
